import React from 'react';

export function ImageUploaderIcon(): JSX.Element {
  return (
    <svg fill='none' height='25' viewBox='0 0 24 25' width='24' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.25 1H2.25C1.83579 1 1.5 1.33579 1.5 1.75V18.75C1.5 19.1642 1.83579 19.5 2.25 19.5H17.25C17.6642 19.5 18 19.1642 18 18.75V1.75C18 1.33579 17.6642 1 17.25 1Z'
        stroke='var(--color-gray-70)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M22.5 6.5V22.75C22.4974 22.9481 22.4176 23.1374 22.2775 23.2775C22.1374 23.4176 21.9481 23.4974 21.75 23.5H7.5'
        stroke='var(--color-gray-70)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M18 15.5H1.5'
        stroke='var(--color-gray-70)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M5 15.5003L10.2 8.07035C10.3302 7.88342 10.5013 7.72861 10.7003 7.61766C10.8992 7.50671 11.1208 7.44253 11.3483 7.43001C11.5758 7.41748 11.8031 7.45692 12.013 7.54535C12.223 7.63377 12.41 7.76886 12.56 7.94035L18 14.2503'
        stroke='var(--color-gray-70)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M6 4C6.29667 4 6.58668 4.08797 6.83336 4.2528C7.08003 4.41762 7.27229 4.65189 7.38582 4.92597C7.49935 5.20006 7.52906 5.50166 7.47118 5.79264C7.4133 6.08361 7.27044 6.35088 7.06066 6.56066C6.85088 6.77044 6.58361 6.9133 6.29264 6.97118C6.00166 7.02906 5.70006 6.99935 5.42597 6.88582C5.15189 6.77229 4.91762 6.58003 4.7528 6.33336C4.58797 6.08668 4.5 5.79667 4.5 5.5C4.5 5.10218 4.65804 4.72064 4.93934 4.43934C5.22064 4.15804 5.60218 4 6 4'
        stroke='var(--color-gray-70)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </svg>
  );
}
